import { CustomSnackComponent } from './custom-snack/custom-snack.component';

export const CustomSnackComponents = { test: CustomSnackComponent };
